import { PropTypes } from 'prop-types'
import { Button, Loading } from 'carbon-components-react'
import { useState, useCallback, useRef } from 'react' 
import AwesomeDebouncePromise from 'awesome-debounce-promise'  

export const LoadingButton = ( {  
    className,
    onClick,
    type, 
    ariaLabel,
    debounce, 
    tabIndex,
    'data-testid': dataTestId,
    children
} ) => {
    
    const [ loading, setLoading ] = useState( false ) 
    const callClick= async ( event ) => { 
            const p = Promise.resolve( onClick( event ) ) 
            p.then( () => setTimeout( () => {
	                setLoading( false )
                }, 1000 )  ) 
        }
    const callClickDebounced = AwesomeDebouncePromise(
        callClick,
         1000, 
    )
    
    const click=( event )=>{
         if ( !loading ) {
                setLoading( true ) 
                if( debounce )
                    callClickDebounced( event )
                else
                    callClick( event )
            }; 
    }
    const renderLoading=( )=>{
        return <div className='center-spinner-current-password-wrapper' >
            <Loading
                description= { null } className="center-spinner center-spinner-current-password" 
                withOverlay={ false } small = { true }
            />                        
        </div>
    }
    const renderButton=()=>{ 
        return <Button  
            className={ className }   
            data-testid={ dataTestId } 
            onClick={ click }
            type={ type } 
            tabIndex={ tabIndex }
            aria-label={ ariaLabel } >  
            { children }
        </Button> 
    }
	return   ( loading ? renderLoading() : renderButton() )
}
LoadingButton.propTypes = { 
    className: PropTypes.string, 
    onClick: PropTypes.func,
    type: PropTypes.string,
    ariaLabel: PropTypes.string,
    tabIndex: PropTypes.number,
    children: PropTypes.node,
    dataTestid: PropTypes.string,
}
